import { Skeleton } from "@mui/material";

type PropsType = {
    count: number,
}

export default function ListSkeleton({count}:PropsType) {
    return (
        <>
            {Array(count)
                .fill(1)
                .map(() => (
                 <Skeleton />
              ))}
        </>
    );
}
